import { FC } from "react";

import { Dialog, Link, Stack, Text } from "@bps/fluent-ui";

interface LicenseDialogProps {
  showModal: boolean;
  onDismiss: () => void;
}
export const LicenseDialog: FC<LicenseDialogProps> = ({
  showModal,
  onDismiss
}) => {
  return (
    <Dialog
      hidden={!showModal}
      maxWidth={500}
      dialogContentProps={{
        title: "Third-party licences",
        showCloseButton: true
      }}
      onDismiss={onDismiss}
    >
      <Stack tokens={{ childrenGap: 8 }}>
        <Text>
          This application makes use of open-source software. We gratefully
          acknowledge the following projects and their contributors.
        </Text>
        <Stack tokens={{ childrenGap: 4 }}>
          <Text bold variant="medium">
            Axe-Core
          </Text>
          <Stack>
            <Text>Accessibility testing library</Text>
            <Text>© Deque Systems, Inc.</Text>
            <Text>Licensed under the Mozilla Public License, v. 2.0.</Text>
            <Link onClick={() => window.open("https://mozilla.org/MPL/2.0/")}>
              https://mozilla.org/MPL/2.0/
            </Link>
            <Text>
              Source:{" "}
              <Link
                onClick={() =>
                  window.open("https://github.com/dequelabs/axe-core")
                }
              >
                github.com/dequelabs/axe-core
              </Link>
            </Text>
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};
